import React, { useEffect, useState } from "react";
import Header2 from "../Header2/header2";
import Footer from "../Footer/footer";
import { useHistory } from 'react-router-dom';
import axios from "axios";
import { API_BASE_URL, IMAGE_URL, IMAGE_URL_UPLOAD } from "@/config/serverApiConfig";
import { Breadcrumb, Spinner } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import country_list from '../all-countries-and-cities-json'
import SubmitPopup from "../Submitpopup/Submitpopup";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
//import { useHistory } from 'react-router-dom';

import { Modal } from 'react-bootstrap';


const UpdateProfile = () => {
  const [submitLoader, setSubmitLoader] = useState(false);
  const [name, setName] = useState(JSON.parse(localStorage.getItem('fname')));


  const history = useHistory();
  if (localStorage.getItem("token") === undefined || localStorage.getItem("token") === null) {
    history.push('/login');
  }



  let token = localStorage.getItem("token");
  useEffect(() => {
    let msg = "getting user by token";
    axios.post(`${API_BASE_URL}user/getUserById`, msg, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-access-token': `${token}`
      }
    }
    )
      .then(res => {


        /* localStorage.setItem("user", JSON.stringify(res.data.user));
        setUser(res.data.user);
        setName(res.data.user.fname); */

        localStorage.setItem("user", JSON.stringify(res.data.decryptedUser));
        setUser(res.data.decryptedUser);
        setFname(res.data.decryptedUser.fname);

      })
      .catch(err => {

      });
  }, []);



  const [show, setShow] = useState(false);
  const [showw, setShoww] = useState(false);
  let [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  //let user = JSON.parse(localStorage.getItem("user"));
  let [fname, setFname] = useState(user.fname);
  let [lname, setLname] = useState(user.lname);
  let [email, setEmail] = useState(user.email);
  let [city, setCity] = useState(user.city);
  let [country, setCountry] = useState(user.country);
  let [phone, setPhone] = useState(user.phone);
  let [scannedcnic, setScannedcnic] = useState(user.scanned_cnic);
  let [certificate, setCertificate] = useState(user.certificate);
  let [reference_one_name, setReference_one_name] = useState(user.reference_one_name);
  let [reference_one_number, setReference_one_number] = useState(user.reference_one_number);
  let [reference_one_email, setReference_one_email] = useState(user.reference_one_email);
  let [reference_two_name, setReference_two_name] = useState(user.reference_two_name);
  let [reference_two_number, setReference_two_number] = useState(user.reference_two_number);
  let [reference_two_email, setReference_two_email] = useState(user.reference_two_email);
  let [mobileNoLength, setMobileNoLength] = useState(false);
  let [mobileNoLengthOne, setMobileNoLengthOne] = useState(false);
  let [mobileNoLengthTwo, setMobileNoLengthTwo] = useState(false);
  const [cityIsEmptyErr, setCityIsEmptyErr] = useState(false);
  const [phoneIsEmptyErr, setPhoneIsEmptyErr] = useState(false);
  const [refTwoNumberIsEmptyErr, setRefTwoNumberIsEmptyErr] = useState(false);
  const [refOneNumberIsEmptyErr, setRefOneNumberIsEmptyErr] = useState(false);
  let [jamatIdCardNumber, setJamatIdCardNumber] = useState(user.jamat_id_card_number || ""); // ⭐️ NEW CODE
  const [jamatIdCardNumberErr, setJamatIdCardNumberErr] = useState(false); // ⭐️ NEW CODE
  const [jamatIdCardNumberIsEmptyErr, setJamatIdCardNumberIsEmptyErr] = useState(false); // ⭐️ NEW CODE


  // creating isempty error for all
  // setFNameIsEmptyErr(true);
  //     setLNameIsEmptyErr(true);
  //     setEmailIsEmptyErr(true);
  //     setPhoneIsEmptyErr(true);
  //     setCountryIsEmptyErr(true);
  //     setCityIsEmptyErr(true);
  //     setRefOneFrirstNameIsEmptyErr(true);
  //     setRefTwoFrirstNameIsEmptyErr(true);
  //     setRefOneNumberIsEmptyErr(true);
  //     setRefTwoNumberIsEmptyErr(true);
  //     setCnicImageIsEmptyErr(true);
  //     setRefOneEmailIsEmptyErr(true);
  //     setRefTwoEmailIsEmptyErr(true);

  const [fNameIsEmptyErr, setFNameIsEmptyErr] = useState(false);
  const [lNameIsEmptyErr, setLNameIsEmptyErr] = useState(false);
  const [emailIsEmptyErr, setEmailIsEmptyErr] = useState(false);
  const [countryIsEmptyErr, setCountryIsEmptyErr] = useState(false);
  const [refOneFrirstNameIsEmptyErr, setRefOneFrirstNameIsEmptyErr] = useState(false);
  const [refTwoFrirstNameIsEmptyErr, setRefTwoFrirstNameIsEmptyErr] = useState(false);
  const [refOneEmailIsEmptyErr, setRefOneEmailIsEmptyErr] = useState(false);
  const [refTwoEmailIsEmptyErr, setRefTwoEmailIsEmptyErr] = useState(false);




  const [smShow, setSmShow] = useState(false);
  const [smShow2, setSmS2how] = useState(false);
  let [updatedMSG, setUpdatedMSG] = useState(false);

  let [countriesData, setcountriesData] = useState([])
  let [cityData, setcityData] = useState([])
  useEffect(() => {
    const country_keys = Object.keys(country_list);



    let countriesListData = country_keys.map((country_item, index) => {
      return (
        <option key={index} value={country_item}>
          {country_item}
        </option>
      );
    })
    setcountriesData(countriesListData)

  }, []);

  useEffect(() => {
    if (country !== undefined && country !== null && country !== "") {
      let citiesListData = country_list[country].map((city_item, index) => {
        return (
          <option key={index} value={city_item}>
            {city_item}
          </option>
        );
      }
      )
      setcityData(citiesListData)
    }
  }, [country])


  const countryChange = (e) => {
    const country_name = e.target.value;

    setCountry(e.target.value);


  };

  function cityHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setCityIsEmptyErr(true);

    } else {

      setCityIsEmptyErr(false);
    }
    setCity(item);

  }

  const phoneHandler = (phone) => {


    let item = phone

    if (item <= 0) {
      setPhoneIsEmptyErr(true);
      setPhoneErr(false);
    } else {
      setPhoneErr(false);
      setPhoneIsEmptyErr(false);
    }
    setPhone(item);


  }

  const referenceOneNumberHandler = (reference_one_number) => {
    let item = reference_one_number;
    if (item === "") {
      setRefOneNumberIsEmptyErr(true);
      setRefOneNumberErr(false);
    } else {
      setRefOneNumberErr(false);
      setRefOneNumberIsEmptyErr(false);
    }
    setReferenceOneNumber(item);

  }

  const validNameRegex = RegExp("([A-Z][a-z]*)([\\s\\'-][A-Z][a-z]*)*");
  function fnameHandler(e) {
    let item = e.target.value;
    let validName = validNameRegex.test(item);
    if (item === "") {
      setFNameIsEmptyErr(true);


    } else if (!validName) {

      setFNameIsEmptyErr(true);
    } else if (item.length < 3 || item.length > 20) {

      setFNameIsEmptyErr(true);
    } else {

      setFNameIsEmptyErr(false);

    }
    setFname(item);

  }

  function lnameHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setLNameIsEmptyErr(true);

    } else if (item.length < 3 || item.length > 20) {

      setLNameIsEmptyErr(true);
    } else {

      setLNameIsEmptyErr(false);
    }
    setLname(item);

  }

  function refOneFrirstNameHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setRefOneFrirstNameIsEmptyErr(true);

    } else if (item.length < 3 || item.length > 20) {
      setRefOneFrirstNameIsEmptyErr(true)
    } else {
      setRefOneFrirstNameIsEmptyErr(false)
    }

    setReference_one_name(item);

  }

  function referenceTwoNameHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setRefTwoFrirstNameIsEmptyErr(true);

    } else if (item.length < 3 || item.length > 20) {

      setRefTwoFrirstNameIsEmptyErr(true);
    } else {

      setRefTwoFrirstNameIsEmptyErr(false);
    }
    setReference_two_name(item);

  }

  const referenceTwoNumberHandler = (reference_two_number) => {
    let item = reference_two_number;
    if (item === "") {
      setRefTwoNumberIsEmptyErr(true);
      setRefTwoNumberErr(false);
    } else {
      setRefTwoNumberErr(false);
      setRefTwoNumberIsEmptyErr(false);
    }
    setReferenceTwoNumber(item);

  }

  let [profileImage, setProfileImage] = useState(user.profileImage);
  const [{ alt, srcurl }, setImg] = useState({
    srcurl: IMAGE_URL_UPLOAD + user.profileImage,
    alt: "Profile Picture",
  });


  const handleImg = (e) => {
    if (e.target.files[0]) {
      setProfileImage(e.target.files[0]);
      setImg({
        srcurl: URL.createObjectURL(e.target.files[0]),
        alt: e.target.files[0].name,
      });
    }
  };

  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );

  function emailHandler(e) {
    let item = e.target.value;

    let validEmail = validEmailRegex.test(item);
    if (!validEmail) {
      setEmailIsEmptyErr(true);

    } else {

      setEmailIsEmptyErr(false);
    }
    setEmail(item);

  }

  function referenceOneEmailHandler(e) {
    let item = e.target.value;
    let validEmail = validEmailRegex.test(item);
    if (!validEmail) {

      setRefOneEmailIsEmptyErr(true);
    } else {

      setRefOneEmailIsEmptyErr(false);
    }
    setReference_one_email(item);
    //formData.append("refOneEmail", reference_one_email);
  }

  function referenceTwoEmailHandler(e) {
    let item = e.target.value;
    let validEmail = validEmailRegex.test(item);
    if (item === "") {
      setRefTwoEmailIsEmptyErr(true);

    } else if (!validEmail) {

      setRefTwoEmailIsEmptyErr(true);
    } else {

      setRefTwoEmailIsEmptyErr(false);
    }
    setReference_two_email(item);
    //formData.append("refTwoEmail", reference_two_email);
  }


  async function submit(event) {
    let formData = new FormData();
    event.preventDefault();

    if (
      fname === "" &&
      lname === "" &&
      email === "" &&
      phone === "" &&
      country === "" &&
      city === "" &&
      refOneFrirstName === "" &&
      refTwoFrirstName === "" &&
      refOnePhone === "" &&
      refTwoPhone === "" &&
      cnicImage === "" &&
      reference_one_name === "" &&
      reference_two_name === "" &&
      reference_one_number === "" &&
      reference_two_number === "" &&
      reference_one_email === "" &&
      reference_two_email === "" &&
      jamatIdCardNumber === "" // ⭐️ NEW CODE
    ) {
      setFNameIsEmptyErr(true);
      setLNameIsEmptyErr(true);
      setEmailIsEmptyErr(true);
      setPhoneIsEmptyErr(true);
      setRefOneFrirstNameIsEmptyErr(true);
      setRefTwoFrirstNameIsEmptyErr(true);
      setRefOneNumberIsEmptyErr(true);
      setRefTwoNumberIsEmptyErr(true);
      setCnicImageIsEmptyErr(true);
      setRefOneEmailIsEmptyErr(true);
      setRefTwoEmailIsEmptyErr(true);
      setJamatIdCardNumberIsEmptyErr(true); // ⭐️ NEW CODE
    } else if (fname === "" || fname.length < 3) {
      setFNameIsEmptyErr(true);
    } else if (lname === "" || lname.length < 3) {
      setLNameIsEmptyErr(true);
    } else if (emailIsEmptyErr === true) {
      setEmailIsEmptyErr(true);

    } else if (phone === "" || phoneIsEmptyErr === true) {
      setPhoneIsEmptyErr(true);
    } else if (country === "") {
      setCountryIsEmptyErr(true);
    } else if (city === "" || city === undefined || city.length < 3) {
      setCityIsEmptyErr(true);
    }

    else if (reference_one_name === "" || reference_one_name.length < 3) {
      setRefOneFrirstNameIsEmptyErr(true);
    } else if (reference_two_name === "" || reference_two_name.length < 3) {
      setRefTwoFrirstNameIsEmptyErr(true);
    } else if (reference_one_number === "" || refOneNumberIsEmptyErr === true) {
      setRefOneNumberIsEmptyErr(true);
    } else if (reference_two_number === "" || refTwoNumberIsEmptyErr === true) {
      setRefTwoNumberIsEmptyErr(true);
    } else if (refOneEmailIsEmptyErr === true) {
      setRefOneEmailIsEmptyErr(true);
    } else if (refTwoEmailIsEmptyErr === true) {
      setRefTwoEmailIsEmptyErr(true);
    } else if (!/^[0-9]{6,20}$/.test(jamatIdCardNumber)) { // ⭐️ NEW CODE
      setJamatIdCardNumberErr(true);
    } else {

      formData.append("fname", fname);
      formData.append("lname", lname);
      formData.append("email", email);
      formData.append("city", city);
      formData.append("country", country);
      formData.append("phone", phone);
      formData.append("scannedcnic", scannedcnic);
      formData.append("certificate", certificate);
      formData.append("reference_one_name", reference_one_name);
      formData.append("reference_one_number", reference_one_number);
      formData.append("reference_one_email", reference_one_email);
      formData.append("reference_two_name", reference_two_name);
      formData.append("reference_two_number", reference_two_number);
      formData.append("reference_two_email", reference_two_email);
      formData.append("profileImage", profileImage);
      formData.append("jamat_id_card_number", jamatIdCardNumber); // ⭐️ NEW CODE
      
      setSubmitLoader(true);
      axios.post(`${API_BASE_URL}user/updateProfile`,
        formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': `${token}`
        }

      })
        .then(function (response) {
          setSubmitLoader(false);
          setUpdatedMSG(true);

          // console.log(response.data);
          // localStorage.setItem('user', JSON.stringify(response.data.user))
          // localStorage.setItem('fname', JSON.stringify(response.data.user.fname))
          // setUser(response.data.user)

          localStorage.setItem('user', JSON.stringify(response.data.decryptedUser));
          localStorage.setItem('fname', JSON.stringify(response.data.decryptedUser.fname));
          setUser(response.data.decryptedUser);

          //window.location.reload();


        })
        .catch(err => {
          setSubmitLoader(false);
          // console.error(err.message);
        })
    }
  }

  async function activateUser(event) {
    event.preventDefault();
    formData.append("block_status", false);
    axios.post(`${API_BASE_URL}user/activateUser`,
      formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-access-token': `${token}`
      }
    }
    )
  }

  async function deActivateUser(event) {
    event.preventDefault();

    let msg = "deactivate user"
    axios.post(`${API_BASE_URL}user/deActivateUser`,
      msg, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-access-token': `${token}`
      }
    }
    ).then(function (response) {
      setSmS2how(true);

    }
    ).catch(err => {
    })
  }

  async function deleteUser(event) {
    event.preventDefault();
    let msg = "delete";
    axios.post(`${API_BASE_URL}user/deleteUser`,
      msg, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-access-token': `${token}`
      }
    }
    ).then(function (response) {
      setSmShow(true);


    }
    ).catch(err => {
    })
  }

  function closeupdateModal() {
    setUpdatedMSG(false);
    // refresh the page
    history.push("/updateProfile");

  }


  function closePopup() {
    setSmShow(false);
    setSmS2how(false);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('fname');
    history.push('/login');
  };


  const handleClose = () => {
    setShow(false)
    setShoww(false)
  }
  const [isDeactivate, setisDeactivate] = useState(false)
  const deactivateFunction = () => {
    setShow(true);
    setisDeactivate(true)
  }
  const deleteFunction = () => {
    setShoww(true);
    setisDeactivate(false)
  }

  return (
    <>
      <Header2 />
      <SubmitPopup
        onClose={closePopup}
        show={smShow}
        title={"Your Account is Deleted"}
      />
      <SubmitPopup
        onClose={closePopup}
        show={smShow2}
        title={"Your Account is De-Activated"}
      />
      <SubmitPopup
        onClose={closeupdateModal}
        show={updatedMSG}
        title={"Your Account is Updated"}
      />
      <Container className="profile-update-sec unread">
        <Breadcrumb className="pt-5 pb-4">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Profile</Breadcrumb.Item>
        </Breadcrumb>
        <form onSubmit={submit}
          encType='multipart/form-data'>
          <Row className='bg-white py-5 mb-5'>
            <Col lg="3" md="12">
              <div className="profile_images_wrap">
                <span className="author-img">
                  <img src={srcurl} style={{ height: "200px", width: "200px", borderRadius: "100px" }} />
                  <div className="upload_image">
                    <input onChange={handleImg} type="file" accept="image/*" className="form-control upload_img" />
                    <img src="..\assets\images\profile_camra.png" />
                  </div>
                </span>
              </div>
            </Col>
            <Col lg="9" md="12">
              <div className="row">

                <Row>
                  <div className="mb-5 profile_discription">
                    <h2 className="h2_medum mb-0" >{name}<span className="edit_profile_btn"></span></h2>
                    <p></p>
                  </div>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="fname">First Name</label>
                    <input type="text" className="form-control border-0 border-bottom bg-transparent" id="fname" placeholder="First Name" value={fname} onChange={fnameHandler} />
                    {fNameIsEmptyErr ? (<span className="error-msg">First name should more than 3 characters</span>) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="lname" >Last Name</label>
                    <input type="text" className="form-control border-0 border-bottom bg-transparent" id="lname" placeholder="Last Name" value={lname} onChange={lnameHandler} />
                    {lNameIsEmptyErr ? (<span className="error-msg">Last name should more than 3 characters</span>) : (""
                    )}
                  </div>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="email" >Email</label>
                    <input type="email" className="form-control border-0 border-bottom bg-transparent" id="email" placeholder="Email" value={email} onChange={emailHandler} />
                    {emailIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid email address</span>
                    ) : (
                      ""
                    )}
                  </div>
                </Row>
                <Row>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="phone" >Phone</label>
                    <PhoneInput
                      inputClass="form-control border-0 border-bottom bg-transparent"
                      id="phone"
                      name="phone"
                      value={phone.toString()}
                      onChange={(value, country, e) => {
                        setPhoneIsEmptyErr(false);
                        setMobileNoLength(country.format?.split(".").length - 1);
                        setPhone(value);
                      }}
                      onBlur={(e, country) => {
                        let _length = country.format?.split(".").length - 1;
                        if (phone.toString().length !== _length) {
                          setPhoneIsEmptyErr(true);
                          autoFocus: true
                        }
                        else {
                          setPhoneIsEmptyErr(false);

                        }
                      }}

                    />
                    {phoneIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 mb-4">
                    <label>
                      Country <span className="req">*</span>
                    </label>

                    <select
                      id="inputCountry"
                      className="form-control border-0 border-bottom bg-transparent"
                      value={country}
                      onChange={countryChange}
                      type="text"
                    >
                      {countriesData}

                    </select>
                  </div>
                  <div
                    className="form-group col-lg-4 mb-4"
                  >
                    <label>
                      City <span className="req">*</span>
                    </label>
                    <select
                      id="inputcity"
                      className={"form-control border-0 border-bottom bg-transparent"}
                      //disabled={country ? false : true}
                      value={city}
                      onChange={cityHandler}
                      type="text"
                    >
                      {cityData}
                    </select>
                  </div>
                </Row>

                {/* ⭐️ NEW FIELD: Jamat ID Card Number */}
                <Row>
                  <div className="form-group col-lg-12 mb-4">
                    <label htmlFor="jamat_id_card_number">
                      Jamat ID Card Number <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control border-0 border-bottom bg-transparent"
                      id="jamat_id_card_number"
                      placeholder="Jamat ID Card Number"
                      value={jamatIdCardNumber}
                      onChange={(e) => {
                        setJamatIdCardNumberErr(false);
                        setJamatIdCardNumberIsEmptyErr(false);
                        setJamatIdCardNumber(e.target.value);
                      }}
                      required
                    />
                    {jamatIdCardNumberIsEmptyErr ? (
                      <span className="error-msg">Please enter Jamat ID Card Number</span>
                    ) : ""}
                    {jamatIdCardNumberErr ? (
                      <span className="error-msg">Enter a valid Jamat ID Card Number (6-20 digits)</span>
                    ) : ""}
                  </div>
                </Row>
                {/* ⭐️ END NEW FIELD */}


                <Row>
                  <div className="form-group col-lg-6 mb-4">
                    <label htmlFor="scannedcnic" >Scanned CNIC</label>
                    <input type="text" disabled className="form-control border-0 border-bottom bg-transparent" id="scannedcnic" placeholder="Scanned CNIC" value={scannedcnic} onChange={(e) => setScannedcnic(e.target.value)} />
                  </div>
                  <div className="form-group col-lg-6 mb-4">
                    <label htmlFor="certificate" >Certificate</label>
                    <input type="text" disabled className="form-control border-0 border-bottom bg-transparent" id="certificate" placeholder="Certificate" value={certificate} onChange={(e) => setCertificate(e.target.value)} />
                  </div>
                </Row>
                <Row>
                  <h3>References from Khoja Community</h3>
                  <span className='reference py-2'>Reference 1:</span>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="reference_one_name" >Reference One Name</label>
                    <input type="text" className="form-control border-0 border-bottom bg-transparent" id="reference_one_name" placeholder="Reference One Name" value={reference_one_name} onChange={refOneFrirstNameHandler} />
                    {refOneFrirstNameIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid name</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="reference_one_number" >Reference One Number</label>
                    <PhoneInput
                      inputClass="form-control border-0 border-bottom bg-transparent"
                      id="phone"
                      name="phone"
                      value={reference_one_number.toString()}
                      onChange={(value, country, e) => {
                        setRefOneNumberIsEmptyErr(false);
                        setMobileNoLengthOne(country.format?.split(".").length - 1);
                        setReference_one_number(value);
                      }}
                      onBlur={(e, country) => {
                        let _length = country.format?.split(".").length - 1;
                        if (reference_one_number.toString().length !== _length) {
                          setRefOneNumberIsEmptyErr(true);
                        }
                        else {
                          setRefOneNumberIsEmptyErr(false);

                        }
                      }}

                    />
                    {refOneNumberIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="reference_one_email" >Reference One Email</label>
                    <input type="text" className="form-control border-0 border-bottom bg-transparent" id="reference_one_email" placeholder="Reference One Email" value={reference_one_email} onChange={referenceOneEmailHandler} />
                    {refOneEmailIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid email address</span>
                    ) : (
                      ""
                    )}
                  </div>
                </Row>
                <Row>
                  <h3>References from Khoja Community</h3>
                  <span className='reference py-2'>Reference 2:</span>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="reference_two_name" >Reference Two Name</label>
                    <input type="text" className="form-control border-0 border-bottom bg-transparent" id="reference_two_name" placeholder="Reference Two Name" value={reference_two_name} onChange={referenceTwoNameHandler} />
                    {refTwoFrirstNameIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid name</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="reference_two_number" >Reference Two Number</label>
                    <PhoneInput
                      inputClass="form-control border-0 border-bottom bg-transparent"
                      id="phone"
                      name="phone"
                      value={reference_two_number.toString()}
                      onChange={(value, country, e) => {
                        setRefTwoNumberIsEmptyErr(false);
                        setMobileNoLengthTwo(country.format?.split(".").length - 1);
                        setReference_two_number(value);
                      }}
                      onBlur={(e, country) => {
                        let _length = country.format?.split(".").length - 1;
                        if (reference_two_number.toString().length !== _length) {
                          setRefTwoNumberIsEmptyErr(true);
                          autoFocus: true
                        }
                        else {
                          setRefTwoNumberIsEmptyErr(false);

                        }
                      }}
                      placeholder={reference_two_number}
                    />
                    {refTwoNumberIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 mb-4">
                    <label htmlFor="reference_two_email" >Reference Two Email</label>
                    <input type="text" className="form-control border-0 border-bottom bg-transparent" id="reference_two_email" placeholder="Reference Two Email" value={reference_two_email} onChange={referenceTwoEmailHandler} />
                    {refTwoEmailIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid email address</span>
                    ) : (
                      ""
                    )}

                  </div>
                </Row>
                <div className="row mt-4">
                  <div className="col-lg-12">
                    <button type="submit" onSubmit={submit} className="btn-full-color"> <Spinner
                      as="span"
                      animation={submitLoader ? 'border' : ''}
                      size="sm"
                      role="status"
                      aria-hidden="false"
                    />Save Changes</button>
                  </div>
                </div>

              </div>
            </Col>
          </Row>
        </form>
        <Modal show={show} onHide={handleClose} className='SubmitPopup'>
          <Modal.Header closeButton className='border-0'></Modal.Header>
          <Modal.Body className='text-center py-5'>
            <p className='pb-3 pt-3'>Are You Sure You want to Deactivate?</p>
            <button type="submit" onClick={isDeactivate ? deActivateUser : deleteUser} className="btn-full-color w-auto px-4 me-4 hover-101D42">Yes</button>
            <button type="submit" onClick={handleClose} className="btn-full-color w-auto px-4 hover-101D42">No</button>
          </Modal.Body>
        </Modal>

        <Modal show={showw} onHide={handleClose} className='SubmitPopup'>
          <Modal.Header closeButton className='border-0'></Modal.Header>
          <Modal.Body className='text-center py-5'>
            <p className='pb-3 pt-3'>Are You Sure You want to Delete?</p>
            <button type="submit" onClick={isDeactivate ? deActivateUser : deleteUser} className="btn-full-color w-auto px-4 me-4 hover-101D42">Yes</button>
            <button type="submit" onClick={handleClose} className="btn-full-color w-auto px-4 hover-101D42">No</button>
          </Modal.Body>
        </Modal>

        <Row className="mb-5">
          <Col className="mb-4">
            <p className="text-center fw-bold">If you think this account is not in your use?</p>
            <Row >
              <Col className="text-center">
                <button type="submit" onClick={deactivateFunction} className="btn-full-color w-auto px-4 me-4 hover-101D42">Deactivate Account</button>
                <button type="submit" onClick={deleteFunction} className="btn-full-color w-auto px-4 hover-101D42">Delete Account</button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  )
}
export default UpdateProfile;